/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Tax_Code_GrantedInputs */

const vi_einvoice_tax_code_granted = /** @type {(inputs: Einvoice_Tax_Code_GrantedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã được cơ quan thuế cấp mã`)
};

/**

* @param {Einvoice_Tax_Code_GrantedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_tax_code_granted = /** @type {((inputs?: Einvoice_Tax_Code_GrantedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Tax_Code_GrantedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_tax_code_granted(inputs)
});